import type { ReactNode } from "react";

/** Compact header for party-hub sub-pages (clients, vendors) inside the white content panel. */
export function HubToolbar({
  title,
  description,
  action,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
}) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-2 border-b border-border px-3 py-1.5">
      <div className="min-w-0">
        <h2 className="text-xs font-semibold tracking-[-0.005em]">{title}</h2>
        {description ? <p className="text-2xs text-muted-foreground">{description}</p> : null}
      </div>
      {action}
    </div>
  );
}
